<template>
  <page-template>
    <template slot="page-content">
      <div class="generic--template food-and-drink page-template bg-beige">
        <!-- <div class="parallax">
          <div
            v-scrollanimation
            class="taste-header ph0 ph5-m ph5-l flex fixed-height realtive"
          >
            <h3 class="f1 is-blenny lh-title font-bigger">
              TASTE OF THE <br class="dn db-ns" />BAY AREA
            </h3>
          </div>
        </div> -->

        <div class="relative bg-sf-color z-content">
          <div class="row relative center mb4 mt4-ns">
            <div class="relative center col-xs-12 col-sm-6 ph0">
              <h1
                class="db dn-ns f-page-title ttu tl center lh-heading pr0-ns is-blenny is-navy mw7-ns"
              >
                {{ page.seo_title }}
              </h1>
              <!-- <div class="center">
                  <div class="icon-div">
                    <img
                    
                    class="mw21rem icon "
                    src="/uploads/OL20-OL21_Icons/Hamburger_Icon/Hamburger_Icon_SVG/Hamburger_Icon_Infrared.svg"
                  />
                  <img
                    
                    class="mw21rem icon "
                    src="/uploads/OL20-OL21_Icons/Hamburger_Icon/Hamburger_Icon_SVG/Hamburger_Icon_Infrared.svg"
                  />
                  <img
                    
                    class="mw21rem icon "
                    src="/uploads/OL20-OL21_Icons/Hamburger_Icon/Hamburger_Icon_SVG/Hamburger_Icon_Infrared.svg"
                  />
                  <img
                    
                    class="mw21rem icon "
                    src="/uploads/OL20-OL21_Icons/Hamburger_Icon/Hamburger_Icon_SVG/Hamburger_Icon_Infrared.svg"
                  />
                  </div>
                </div> -->
            </div>
          </div>
          <div class="relative container-fluid  mw9 center taste-top">
            <div class="row relative center height-rest mb4 mt4-ns">
              <div class="w-100  col-sm-6">
                <!-- <bg-vimeo-video
                  v-if="page.has_bg_video"
                  :vimeoVideoId="page.background_video_vimeo_id"
                ></bg-vimeo-video>
                <img
                  v-else-if="page.hero_image"
                  class="img-responsive"
                  :src="page.hero_image"
                />
                <img
                  v-else
                  class="img-responsive"
                  src="/uploads/9084_Aug10_Gorlin.jpg"
                /> -->
                <Slider animation="fade" :duration="5000" :speed="1000">
                  <SliderItem
                    v-for="(i, index) in list"
                    :key="index"
                    @click="changeIndex(1)"
                  >
                    <img
                      :src="
                        `/uploads/NUM-RES/OUTSIDE-RES-${
                          newArray2[index + 1]
                        }.jpg`
                      "
                    />
                    <!-- Page{{ index + 1 }} -->
                  </SliderItem>
                </Slider>
              </div>

              <div class="relative col-xs-12 col-sm-6 ph0">
                <h1
                  v-scrollanimation
                  class="show-mobile des-rest2 relative mb4 mb4-ns w-100 f22px is-tablet-regular link-bold lh-copy cms-content"
                >
                  {{ page.intro_text }}
                </h1>
                <div class="dn des-rest db-ns abs-vert-center center">
                  <h1
                    class="mw7-ns tl center pl3 fiveem lh-heading ttu is-blenny is-navy"
                  >
                    {{ page.seo_title }}
                  </h1>
                  <div
                    class="db des-rest2 relative mb4 mb4-ns w-100 f22px is-tablet-regular link-bold lh-copy cms-content"
                  >
                    <!-- v-if="page.intro_text"
                    v-html="marked(page.intro_text)" -->
                    {{ page.intro_text }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <fixedbg :background="`/uploads/NUM-RES/OUTSIDE-RES-${newArray[4]}.jpg`">
        <template slot="contents">
          <accolades-static>
            <template slot="fixed-bg-contents">
              <div class="" v-html="`/uploads/NUM-RES/OUTSIDE-RES-${newArray[4]}.jpg`"></div>
            </template>
          </accolades-static>
        </template>
      </fixedbg> -->

          <!-- <div v-scrollanimation class="relative">
                <h1
                  
                  class="db dn-ns f-page-title ttu tl center lh-heading pr0-ns is-blenny is-navy mw7-ns"
                >
                  {{ page.seo_title }}
                </h1>
                <div class="center">
                  <div class="icon-div">
                    <img
                   
                    class="mw21rem icon "
                    src="/uploads/OL20-OL21_Icons/Food_Truck_Icon/Food_Truck_Icon_SVG/FoodTruck_Icon_Infrared.svg"
                  />
                  <img
                    
                    class="mw21rem icon "
                    src="/uploads/OL20-OL21_Icons/Food_Truck_Icon/Food_Truck_Icon_SVG/FoodTruck_Icon_Infrared.svg"
                  />
                  <img
                    
                    class="mw21rem icon "
                    src="/uploads/OL20-OL21_Icons/Food_Truck_Icon/Food_Truck_Icon_SVG/FoodTruck_Icon_Infrared.svg"
                  />
                  <img
                    
                    class="mw21rem icon "
                    src="/uploads/OL20-OL21_Icons/Food_Truck_Icon/Food_Truck_Icon_SVG/FoodTruck_Icon_Infrared.svg"
                  />
                  </div>
                  <h1
                    class="mw7-ns tc center pl3 lh-heading f-page-title ttu is-blenny is-navy"
                  >
                    Restaurant List
                  </h1>
                  <div class="icon-div">
                    <img
                   
                    class="mw21rem icon "
                    src="/uploads/OL20-OL21_Icons/Food_Truck_Icon/Food_Truck_Icon_SVG/FoodTruck_Icon_Infrared.svg"
                  />
                  <img
                    
                    class="mw21rem icon "
                    src="/uploads/OL20-OL21_Icons/Food_Truck_Icon/Food_Truck_Icon_SVG/FoodTruck_Icon_Infrared.svg"
                  />
                  <img
                    
                    class="mw21rem icon "
                    src="/uploads/OL20-OL21_Icons/Food_Truck_Icon/Food_Truck_Icon_SVG/FoodTruck_Icon_Infrared.svg"
                  />
                  <img
                    
                    class="mw21rem icon "
                    src="/uploads/OL20-OL21_Icons/Food_Truck_Icon/Food_Truck_Icon_SVG/FoodTruck_Icon_Infrared.svg"
                  />
                  </div>
                </div>
              </div> -->
          <section class="relative">
            <div class="relative container-fluid center smaller-list rest-list">
              <h1 class="center is-tablet-bold is-navy second-title">
                Restaurant Partners
              </h1>
              <div
                class="is-navy key-css3 db relative w-100 f22px is-tablet-regular link-bold lh-copy cms-content"
                v-if="page.restaurant_section.sub_text"
                v-html="marked(page.restaurant_section.sub_text)"
              ></div>
              <div class="row center lil-smaller">
                <div class="restaurant-border col-sm-10 mt0 mt4-ns">
                  <!-- <div
                    class="db relative w-100 f22px is-tablet-regular link-bold lh-copy cms-content"
                    v-if="page.restaurant_section.sub_text"
                    v-html="marked(page.restaurant_section.sub_text)"
                  ></div> -->
                  <div v-scrollanimation class="row mt4">
                    <div
                      class="col-xs-12 col-sm-3 pb4"
                      v-for="(restaurant, index) in restData"
                      :key="'restaurant-key-' + index"
                    >
                      <a
                        class="flex relative flex-row items-center text-nowrap is-tablet-bold f24px ttn is-navy rest-partner"
                        :href="restaurant.website"
                        :title="restaurant.title"
                        target="_blank"
                      >
                        <h4 class="is-tablet-bold is-black text-nowrap f20px">
                          {{ restaurant.title }}
                          <simple-svg
                            class="vendor-arrow r45 nl2 pb2 pr1"
                            :filepath="'/uploads/checkout-arrow.svg'"
                          ></simple-svg>
                          <div class="smaller-logos">
                            <span
                              v-if="
                                restaurant.diet ===
                                  `At least one of our items will be vegetarian (or can be adjusted upon request), At least one of our items will be gluten-free (or can be adjusted upon request)`
                              "
                              class="takeout-icon"
                              ><strong>V / GF</strong></span
                            >
                            <span
                              v-if="
                                restaurant.diet ===
                                  `At least one of our items will be vegetarian (or can be adjusted upon request), At least one of our items will be vegan (or can be adjusted upon request), At least one of our items will be gluten-free (or can be adjusted upon request)`
                              "
                              class="delivery-icon is-red"
                              ><strong>V / VG / GF </strong></span
                            >
                            <span
                              v-if="
                                restaurant.diet ===
                                  `At least one of our items will be vegetarian (or can be adjusted upon request)`
                              "
                              class="outdoor-icon"
                              ><strong>V</strong></span
                            >
                            <span
                              v-if="
                                restaurant.diet ===
                                  `At least one of our items will be vegetarian (or can be adjusted upon request), At least one of our items will be vegan (or can be adjusted upon request)`
                              "
                              class="outdoor-icon"
                              ><strong>V / VG</strong></span
                            >
                            <span
                              v-if="
                                restaurant.diet ===
                                  `At least one of our items will be gluten-free (or can be adjusted upon request)`
                              "
                              class="outdoor-icon"
                              ><strong>GF</strong></span
                            >
                            <span v-else class=""></span>
                          </div>
                        </h4>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="pic-left">
                <div
                  v-scrollanimation
                  class="dn db-ns bigger-img icon-image relative nt4 nl5-ns"
                >
                  <img
                    v-scrollanimation
                    class="mw21rem pic-margin"
                    src="/uploads/NUM-RES/OUTSIDE-RES-1.jpg"
                  />
                  <!-- <img
                    v-scrollanimation
                    class="mw21rem icon-2 icon-margin"
                    src="/uploads/OL20-OL21_Icons/Fork_Knife Icon/Fork_Knife_Icon_SVG/Fork_Knife_Icon_Blue.svg"
                  /> -->
                  <img
                    v-scrollanimation
                    class="mw21rem pic-margin"
                    src="/uploads/NUM-RES/OUTSIDE-RES-2.jpg"
                  />
                  <img
                    v-scrollanimation
                    class="mw21rem icon-2 icon-margin"
                    src="/uploads/OL20-OL21_Icons/Food_Truck_Icon/Food_Truck_Icon_SVG/FoodTruck_Icon_Infrared.svg"
                  />
                  <img
                    v-scrollanimation
                    class="mw21rem pic-margin"
                    src="/uploads/NUM-RES/OUTSIDE-RES-3.jpg"
                  />
                </div>
              </div>
              <div class="pic-right">
                <div
                  v-scrollanimation
                  class="dn db-ns bigger-img icon-image relative nt4 nl5-ns"
                >
                  <img
                    v-scrollanimation
                    class="mw21rem pic-margin"
                    src="/uploads/NUM-RES/OUTSIDE-RES-4.jpg"
                  />
                  <img
                    v-scrollanimation
                    class="mw21rem icon icon-margin"
                    src="/uploads/OL20-OL21_Icons/Hamburger_Icon/Hamburger_Icon_SVG/Hamburger_Icon_Infrared.svg"
                  />
                  <img
                    v-scrollanimation
                    class="mw21rem pic-margin"
                    src="/uploads/NUM-RES/OUTSIDE-RES-5.jpg"
                  />
                  <img
                    v-scrollanimation
                    class="mw21rem icon icon-margin"
                    src="/uploads/OL20-OL21_Icons/Cheese_Icon/Cheese_Icon_SVG/Cheese_Icon_Blue.svg"
                  />
                  <img
                    v-scrollanimation
                    class="mw21rem pic-margin"
                    src="/uploads/NUM-RES/OUTSIDE-RES-6.jpg"
                  />
                </div>
              </div>
            </div>
            <div class="relative container-fluid height-rest mw9 center"></div>
          </section>
        </div>

        <div
          class="relative bg-light-blue z-content mb5"
          v-if="
            isWindowWidthMobile == true &&
              page.featured_content_section.is_published
          "
        >
          <section class="relative center pv4 is-black">
            <swiper :options="swiperOptions" ref="mySwiper">
              <swiper-slide>
                <div class="relative container-fluid">
                  <div class="db w-100">
                    <img
                      class="db relative center img-responsive w-100"
                      :src="page.featured_content_section.content['0'].image"
                      :alt="
                        page.featured_content_section.content['0'].image.alt
                      "
                    />
                    <h3 class="f20px is-tablet-cond-bold mt4 mb3">
                      {{ page.featured_content_section.content["0"].title }}
                    </h3>
                    <p class="f15px is-tablet-regular mb3 lh-copy">
                      {{ page.featured_content_section.content["0"].text }}
                    </p>
                    <a
                      class="f15px is-tablet-bold"
                      :title="
                        page.featured_content_section.content['0'].link_title
                      "
                      :href="page.featured_content_section.content['0'].link"
                      >{{
                        page.featured_content_section.content["0"].button_text
                      }}<simple-svg
                        class="checkout"
                        :filepath="'/uploads/checkout-arrow.svg'"
                      ></simple-svg
                    ></a>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="relative container-fluid">
                  <div class="db w-100">
                    <img
                      class="db relative center img-responsive w-100"
                      :src="page.featured_content_section.content['1'].image"
                      :alt="
                        page.featured_content_section.content['1'].image.alt
                      "
                    />
                    <h3 class="f20px is-tablet-cond-bold mt4 mb3">
                      {{ page.featured_content_section.content["1"].title }}
                    </h3>
                    <p class="f15px is-tablet-regular mb3 lh-copy">
                      {{ page.featured_content_section.content["1"].text }}
                    </p>
                    <a
                      class="f15px is-tablet-bold"
                      :title="
                        page.featured_content_section.content['1'].link_title
                      "
                      :href="page.featured_content_section.content['1'].link"
                      >{{
                        page.featured_content_section.content["1"].button_text
                      }}<simple-svg
                        class="checkout"
                        :filepath="'/uploads/checkout-arrow.svg'"
                      ></simple-svg
                    ></a>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
          </section>
        </div>

        <div
          class="relative bg-light-blue z-content mb5 mt4"
          v-if="
            isWindowWidthMobile == false &&
              page.featured_content_section.is_published
          "
        >
          <div class="relative container-fluid">
            <section class="relative center mw8 pt5 pb5 is-black">
              <div class="row">
                <div class="col-xs-12 col-sm-6 pr5-ns br-ns b--is-cream">
                  <img
                    class="db relative center img-responsive w-100"
                    :src="page.featured_content_section.content['0'].image"
                    :alt="page.featured_content_section.content['0'].image.alt"
                  />
                  <h3 class="f20px is-tablet-cond-bold mt4 mb3">
                    {{ page.featured_content_section.content["0"].title }}
                  </h3>
                  <p class="f15px is-tablet-regular mb3 lh-copy">
                    {{ page.featured_content_section.content["0"].text }}
                  </p>
                  <a
                    class="f15px is-tablet-bold"
                    :title="
                      page.featured_content_section.content['0'].link_title
                    "
                    :href="page.featured_content_section.content['0'].link"
                    >{{ page.featured_content_section.content["0"].button_text
                    }}<simple-svg
                      class="checkout"
                      :filepath="'/uploads/checkout-arrow.svg'"
                    ></simple-svg
                  ></a>
                </div>
                <div class="col-xs-12 col-sm-6 pl5-ns pt5 pt0-m pt0-l">
                  <img
                    class="db relative center img-responsive w-100 pt4 pt0-m pt0-l"
                    :src="page.featured_content_section.content['1'].image"
                    :alt="page.featured_content_section.content['1'].image.alt"
                  />
                  <h3 class="f20px is-tablet-cond-bold mt4 mb3">
                    {{ page.featured_content_section.content["1"].title }}
                  </h3>
                  <p class="f15px is-tablet-regular mb3 lh-copy">
                    {{ page.featured_content_section.content["1"].text }}
                  </p>
                  <a
                    class="f15px is-tablet-bold"
                    :title="
                      page.featured_content_section.content['1'].link_title
                    "
                    :href="page.featured_content_section.content['1'].link"
                    >{{ page.featured_content_section.content["1"].button_text
                    }}<simple-svg
                      class="checkout"
                      :filepath="'/uploads/checkout-arrow.svg'"
                    ></simple-svg
                  ></a>
                </div>
              </div>
            </section>
          </div>
        </div>
        <!-- <div class="key-css">
          <h1 class="is-tablet-bold is-navy spanner-change">Key:</h1>

          <div class="key-inner">
            <span class="margin-span"
              ><h1 class="is-tablet-bold is-navy">V = VEGETARIAN</h1></span
            ><span class="margin-span"
              ><h1 class="is-tablet-bold is-navy">VE = VEGAN</h1></span
            ><span class="margin-span"
              ><h1 class="is-tablet-bold is-navy">GF = GLUTEN-FREE</h1></span
            ><span class="margin-span"
              ><h1 class="is-tablet-bold is-navy">
                GGC = GOLDEN GATE CLUB
              </h1></span
            >
          </div>
        </div> -->
        <div class="relative z-content bg-beige pv5 spotlight-up">
          <h1 class="center is-tablet-bold is-navy second-title">
            Restaurant Spotlight
          </h1>
          <section
            id="featured_content_carousel"
            class="relative center pv4 is-black"
          >
            <div
              class="swiper-button-prev-home outline-0 absolute h-100 z-6"
              slot="button-prev"
            ></div>
            <swiper :options="swiperOptions" ref="mySwiper">
              <swiper-slide
                v-for="(featured, index) in featuredContentSlidesFiltered"
                :key="'featured-carousel-item' + index"
              >
                <a
                  :href="featured.website"
                  :title="featured.title"
                  target="_blank"
                  class="relative slide fl"
                >
                  <div class="db w-100">
                    <div class="db relative center img-main fl z-2">
                      <img :src="featured.image" :alt="featured.title" />
                    </div>
                    <div class="dib relative fl z-2 img-icon">
                      <img
                        class="absolute abs-vert-center"
                        :src="featured.icon_image"
                        :alt="featured.title + ' Icon'"
                      />
                    </div>
                    <div class="dib content-info fl relative z-2">
                      <h3 class="f22px is-tablet-bold mt4 mb3">
                        {{ featured.title }}
                      </h3>
                      <p class="f18px is-tablet-regular">{{ featured.bio }}</p>
                    </div>
                  </div>
                </a>
              </swiper-slide>
              <div
                class="swiper-pagination swiper-pagination-bullets"
                slot="pagination"
              ></div>
            </swiper>
            <div
              class="swiper-button-next-home outline-0 absolute h-100 z-6"
              slot="button-next"
            ></div>
          </section>
        </div>
      </div>
    </template>
  </page-template>
</template>

<script>
import PageTemplate from "./page-template.vue";
import Fixedbg from "./fixedbg.vue";
import AccoladesSwiper from "./accolades-swiper.vue";
import AccoladesStatic from "./accolades-static.vue";
import { Slider, SliderItem } from "vue-easy-slider";
import RestData from "../../rest-2021.json";

export default {
  components: {
    AccoladesSwiper,
    AccoladesStatic,
    PageTemplate,
    Fixedbg,
    Slider,
    SliderItem
  },
  props: ["id", "pageMarkdownFileName"],
  metaInfo() {
    return {
      title: this.page.seo_title,
      titleTemplate: titleChunk => {
        return titleChunk
          ? `${titleChunk} | ` + this.$site_seo_title_suffix
          : this.$site_seo_title_suffix;
      },
      meta: [
        {
          vmid: "description",
          name: "description",
          content: this.page.seo_description
        }
      ]
    };
  },
  data() {
    return {
      restData: RestData,
      pic1: "",
      newArray: [],
      newArray2: [],
      bgOpaciy: 0,
      bgScrollStart: 10,
      scrollPos: 0,
      parallax: null,
      swiperOptions: {
        speed: 700,
        autoplayDisableOnInteraction: false,
        loop: true,
        initialSlide: 0,
        paginationClickable: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet(index, className) {
            return `<span class="${className} swiper-pagination-bullet-custom"></span>`;
          }
        },
        keyboardControl: true,
        navigation: {
          nextEl: ".swiper-button-next-home",
          prevEl: ".swiper-button-prev-home"
        },
        initialSlide: 0,
        spaceBetween: 0,
        centeredSlides: true,
        slidesPerView: 2.2,
        afterLoad: false,
        breakpoints: {
          540: {
            slidesPerView: 1.3
          },
          840: {
            slidesPerView: 1.8,
            loopAdditionalSlides: 1
          }
        }
      },
      window: {
        width: 0,
        height: 0
      },
      list: [
        { width: "100%", height: "100%" },
        { width: "100%", height: "100%" },
        { width: "100%", height: "100%" },
        { width: "100%", height: "100%" },
        { width: "100%", height: "100%" },
        { width: "100%", height: "100%" }
      ],
      sliderValue: 2,
      isWindowWidthMobile: false,
      images: [
        `/uploads/NUM-RES/OUTSIDE-RES-1.jpg`,
        "/uploads/NUM-RES/OUTSIDE-RES-2.jpg",
        "/uploads/NUM-RES/OUTSIDE-RES-3.jpg",
        "/uploads/NUM-RES/OUTSIDE-RES-4.jpg"
      ],
      currentNumber: 0,
      timer: null
    };
  },
  computed: {
    page: function() {
      var pageData = this.$store.getters.filterPagesByName(
        "restaurant-partners.markdown"
      );
      return pageData[0];
    },
    currentImage: function() {
      return this.images[Math.abs(this.currentNumber) % this.images.length];
    },
    swiper() {
      if (this.$refs.mySwiper) return this.$refs.mySwiper.swiper;
    },
    featuredContentSlidesFiltered: function() {
      // const slides = this.restData;
      const slides = [
        this.restData[this.newArray[0]],
        this.restData[this.newArray[1]],
        this.restData[this.newArray[2]],
        this.restData[this.newArray[3]],
        this.restData[this.newArray[4]],
        this.restData[this.newArray[5]]
      ];
      const newSlides = slides.filter(slide => slide.is_published === "TRUE");
      if (!slides) return;

      // const slidesFiltered = [...slides].filter(
      //   slide => slide.is_published === true
      // );
      return newSlides;
      //return slides;

    }
  },
  methods: {
    sizing: function() {
      this.windowWidth = window.innerWidth;
      if (this.windowWidth < 768) this.isWindowWidthMobile = true;
      else {
        this.isWindowWidthMobile = false;
      }
    },
    randomNumber() {
      this.pic1 = Math.floor(Math.random() * (23 - 1) + 23);
      console.log("random num pic1 - ", this.pic1);
    },
    startRotation: function() {
      this.timer = setInterval(this.next, 3000);
    },

    stopRotation: function() {
      clearTimeout(this.timer);
      this.timer = null;
    },

    next: function() {
      this.currentNumber += 1;
    },
    prev: function() {
      this.currentNumber -= 1;
    },
    changeIndex(index) {
      this.sliderValue = index;
    }
  },
  created() {
    /* window.addEventListener('resize', this.scrollBg);
    window.addEventListener('scroll', this.scrollBg);
    window.addEventListener('load', this.scrollBg); */
    window.addEventListener("resize", this.sizing);
    window.addEventListener("load", this.sizing);
    this.randomNumber();
  },
  beforeMount() {
    //
  },
  mounted() {
    this.startRotation();
    this.$nextTick(() => {
      //
    });
    function shuffle(array) {
      var tmp,
        current,
        top = array.length;

      if (top)
        while (--top) {
          current = Math.floor(Math.random() * (top + 1));
          tmp = array[current];
          array[current] = array[top];
          array[top] = tmp;
        }

      return array;

      setTimeout(
        () =>
          (this.list = [
            {
              backgroundColor: "#3f51b5",
              width: "100%",
              height: "100%"
            },
            {
              backgroundColor: "#eee",
              width: "100%",
              height: "100%"
            },
            {
              backgroundColor: "#f44336",
              width: "100%",
              height: "100%"
            },
            {
              backgroundColor: "#eee",
              width: "100%",
              height: "100%"
            }
          ]),
        1000
      );
    }

    let picArray = [
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31,
      32,
      33,
      34,
      35,
      36,
      37,
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      48,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      58
    ];

    let picArray2 = [
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23
    ];

    this.newArray = shuffle(picArray);
    this.newArray2 = shuffle(picArray2);
    console.log(this.newArray[0]);
    /* 
		console.log(this.newArray[1]);
    console.log(this.newArray[2]);
    console.log(this.newArray[3]);
    console.log(this.newArray[4]);
    console.log(this.newArray[5]); 
		*/
  },
  beforeDestroy() {
    //
  },
  destroyed() {
    window.removeEventListener("resize", this.sizing);
    //window.removeEventListener('scroll', this.scrollBg);
    window.removeEventListener("load", this.sizing);
  }
};
</script>
